import { LitElement, html, css } from 'lit';
import { msg,str } from '@lit/localize';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { accessibility,grid,details, formStyles} from '../../utilities/styles';
import { EventManager } from '../../utilities/events';
import { search, address, calendar, expandIcon, collapseIcon }  from '../../utilities/icons';
import { dateToMaybeRange } from '../../utilities/eventUtilities.js';
import { languages } from '../../utilities/formsUtilities.js';
export class AllInListingsFilters extends LitElement {
    static properties = {
        name: { type: String },
        show: { type: String },
        addressSearch: { type: String },
        search: { type: String },
        total: { type: Number },
        listingType: { type: String },
        type: { type: Array },
        format: {type: Array },
        //format: {type: Array },
        price: { type: String },
        typeList: { type: String },
        dates: { type: String },
        start_date: { type: String },
        end_date: { type: String },
        accessibility: { type: Array },
        artform: {type: Array},
        supportType: {type: Array},
        operationIn: {type: Array},
        accessibilityList: { type: String },
        supportTypesList: { type: String },
        artformsList: { type: String },
        operationInList: { type: String },
        types: { type: Array },
        formats: {type: Array },
        prices: { type:Array },
        supportTypes: {type:Array},
        artforms: {type:Array},
        operationIns: {type:Array},
        orderSort: {type:String},
        accessibilities: { type: Array },
        language: { type: String },
        languages: { type: Array },
        _total: { state: true,type: Number },
        _type: { state: true,type: Array },
        _accessibility: { state: true,type: Array },
        _supportTypes: { state: true,type: Array },
        _artforms: { state: true,type: Array },
        _operationIn: { state: true,type: Array },
        _dateRangeString: { state: true,type: String },
        _language: { state: true,type: String },
    }

    constructor() {
        super();
        this._dateRangeString = msg("Date range");
    }

    async connectedCallback() {
        super.connectedCallback();
        if(this.total){
            this._total = this.total;
        }
        if(this.listingType){
            this.listingString = this.listingType.replace(/[-_]/g,' ');
        }
        this.eventManager = new EventManager(this);
        this.eventManager.listen(`allin-location-listings-filtered-${this.name}`, this._handleFiltered.bind(this));
    }
    
    firstUpdated(){
        if(this.dates&& this.show!='search'){
            this._setInitialDates();
        }
    }

    disconnectedCallback(){
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }

    get form() {
        return this.shadowRoot.querySelector('form');
    }

    updated(changedProperties){
        if(changedProperties.has('total')||changedProperties.has('typeList')||changedProperties.has('accessibilityList')||changedProperties.has('supportTypesList')||changedProperties.has('artformsList')||changedProperties.has('operationInList')){
            this._total = this.total;
            if(this.typeList){
                this._type = JSON.parse(this.typeList);
            }
            if(this.accessibilityList){
                this._accessibility = JSON.parse(this.accessibilityList);
            }
            if(this.supportTypesList){
                this._supportTypes = JSON.parse(this.supportTypesList);
            }
            if(this.artformsList){
                this._artforms = JSON.parse(this.artformsList);
            }
            if(this.operationInList){
                this._operationIn = JSON.parse(this.operationInList);
            }
            if(this.language){
                this._language = this.language;
            }
        }
    }

    render() {
        let main;
        if(this.show=='search'){
            let filterMessage = '';
            let totalMessage = '';
            let reset = '';
            if(this.hasFilters()){
                let filterLoop = [];
                if(this.search && this.search.length>0){
                    filterLoop.push(html`Search term: ${this.search}`);
                }
                if(this.addressSearch && this.addressSearch.length>0){
                    filterLoop.push(html`Address: ${this.addressSearch}`);
                }
                if(this._type && this._type.length>0){
                    if(!Array.isArray(this._type)){
                        this._type = [this._type];
                    }
                    this._type.forEach(type => {
                        let label = this.types.find(t => t.name === type)?.label ?? type;
                        filterLoop.push(label);
                    });
                }
                if(this._accessibility && this._accessibility.length>0){
                    if(!Array.isArray(this._accessibility)){
                        this._accessibility = [this._accessibility];
                    }
                    this._accessibility.forEach(accessibility => {
                        let label = this.accessibilities.find(a => a.name === accessibility)?.label ?? accessibility;
                        filterLoop.push(label);
                    });
                }
                if(this._supportTypes && this._supportTypes.length>0){
                    if(!Array.isArray(this._supportTypes)){
                        this._supportTypes = [this._supportTypes];
                    }
                    this._supportTypes.forEach(supportType => {
                        let label = this.supportTypes.find(s => s.name === supportType)?.label ?? supportType;
                        filterLoop.push(label);
                    });
                }
                if(this._artforms && this._artforms.length>0){
                    if(!Array.isArray(this._artforms)){
                        this._artforms = [this._artforms];
                    }
                    this._artforms.forEach(artform => {
                        let label = this.artforms.find(a => a.name === artform)?.label ?? artform;
                        filterLoop.push(label);
                    });
                }
                if(this._operationIn && this._operationIn.length>0){
                    if(!Array.isArray(this._operationIn)){
                        this._operationIn = [this._operationIn];
                    }
                    this._operationIn.forEach(operation => {
                        let label = this.operationIns.find(o => o.name === operation)?.label ?? operation;
                        filterLoop.push(label);
                    });
                }
                if(this.start_date || this.end_date){
                    if(this.dates){
                        if(this.dates=='custom'){
                            let dateRangeString  = dateToMaybeRange(this.start_date,this.end_date);
                            filterLoop.push(dateRangeString);
                        }
                        else{
                            let dateString = this.dates.replace(/-/g,' ');
                            dateString = `${dateString.charAt(0).toUpperCase()}${dateString.slice(1)}`;
                            filterLoop.push(dateString);
                        }
                    }
                }
                if(this.price && this.price!=='All'){
                    filterLoop.push(this.price);
                }
                // if(this.format){
                //     console.log(this.format);
                //     this.format = this.format.map(formatName=>{
                //         return formatName.replace(/([a-z])([A-Z])/g, '$1 $2');
                //     });
                //     filterLoop.push(this.format);
                // }
                if (this.format && this.format.length > 0) {
                    this.format
                    .map(formatName =>
                    formatName.replace(/([a-z])([A-Z])/g, '$1 $2')
                    )
                    .forEach(format => {
                    filterLoop.push(format);
                    });
                }
              /*   if(this._language && this._language!=='en'){
                    filterLoop.push(languages[this._language]??this._language);
                } */
                filterMessage = filterLoop.length?html`filtered by: ${filterLoop.map(filter=>html`<strong>${filter}</strong> `)}`:"";
                //alert("Filters: " + filterLoop);
                reset = html`<input type="reset" value="${msg(`Clear all filters`)}" @click=${this._handleReset} />`;

                if(this._total && this._total>0){
                    console.log(this._total);
                    totalMessage = filterLoop.length?msg(str`Showing ${this._total} result${this._total !== 1 ? 's' : ''}`):msg(str`Showing ${this._total !== 1 ? 'all' : ''} ${this._total} result${this._total !== 1 ? 's' : ''}`);
                }
                else{
                    totalMessage = msg(`No results found`);
                }
            } 

            // Always show the results count
            if (this._total > 0) {
                totalMessage = this.hasFilters()
                    ? msg(str`Showing ${this._total} result${this._total !== 1 ? 's' : ''}`)
                    : msg(str`Showing ${this._total !== 1 ? 'all' : ''} ${this._total} result${this._total !== 1 ? 's' : ''}`);
            } else {
                totalMessage = msg(`No results found`);
            }


            
            let orderSort = '';
            if(this.orderSort){
                orderSort = html`
                <div class="flex ordering">
                    <label for="orderSort">${msg('Sort by date')}</label>
                    <select name="orderSort" id="orderSort" @change=${this._handleSubmit}>
                        <option value="asc" ?selected=${this.orderSort=='asc'}>Soonest</option>
                        <option value="desc" ?selected=${this.orderSort=='desc'}>Latest</option>
                    </select>
                </div>`;
            }
            main=html`
            <form>
                <div class="searchboxes">
                    <div class="searchbox">
                        <label for="allin-listings-search">${msg("Search")} ${this.listingString}</label>
                        ${search}
                        <input type="text" id="allin-listings-search" name="search" value="${this.search}" />
                    </div>
                    <div class="searchbox">
                        <label for="allin-listings-address-search">${msg("Search address")}</label>
                        ${address}
                        <input type="text" id="allin-listings-address-search" name="addressSearch" value="${this.addressSearch}" />
                    </div>
                    <input type="submit" value="${msg(`Search`)}" @click=${this._handleSubmit} />
                </div>
                <div class="border-top flex">
                    <p>${totalMessage} ${filterMessage}</p>
                    ${reset}
                </div>
                ${orderSort}
            </form>
           `;
        }
        else{
            let typesHtml = '';
            let accessibilitiesHtml = '';
            let datesHtml = '';
            let formatHtml = '';
            let pricesHtml ='';
            let supportTypesHtml = '';
            let artformsHtml = '';
            let operationInHtml = '';
            let languagesHtml = '';
            if(this.types && this.types.length>0){
                let typesTitle = html`${msg("What do you want to do?")}`;
                if(this.dates!==undefined){
                    typesTitle = html`${msg("What do you want to see?")}`;
                }
                typesHtml = html`
                <details class="filters" ?open="${this.type.length}">
                    <summary>${typesTitle}</summary>
                    <div class="panel">
                        ${this.types.map(type => html`
                            <div class="input-group">
                                ${this.type.includes(type.name)?
                                html`
                                    <input type="checkbox" name="type" id="type-${type.name}" value="${type.name}" checked />
                                `:
                                html`
                                    <input type="checkbox" name="type" id="type-${type.name}" value="${type.name}" />
                                    `
                                }
                                <label for="type-${type.name}">
                                    ${type.label}
                                </label>
                            </div>
                        `)}
                    </div>
                </details>
                `;
            }
            if(this.dates!==undefined){
                datesHtml = html`
                <details class="filters" ?open="${this.dates}">
                    <summary>${msg("Date")}</summary>
                        <div class="panel">
                            <div class="input-group">
                                ${this.dates === ''
                                    ? html`<input type="radio" name="dates" id="date-all" value="" checked @change=${this._dateChange.bind(this)}/>`
                                    : html`<input type="radio" name="dates" id="date-all" value="" @change=${this._dateChange.bind(this)}/>`
                                }
                                <label for="date-all">${msg("All dates")}</label>
                            </div>
                            <div class="input-group">
                                ${this.dates=='today'
                                    ? html`<input type="radio" name="dates" id="today" value="today" checked @change=${this._dateChange.bind(this)}/>`
                                    : html`<input type="radio" name="dates" id="today" value="today" @change=${this._dateChange.bind(this)}/>`
                                }
                                <label for="today">${msg("Today")}</label>
                            </div>
                            <div class="input-group">
                                ${this.dates=='tomorrow'
                                    ? html`<input type="radio" name="dates" id="tomorrow" value="tomorrow" checked @change=${this._dateChange.bind(this)}/>`
                                    : html`<input type="radio" name="dates" id="tomorrow" value="tomorrow" @change=${this._dateChange.bind(this)}/>`
                                }
                                <label for="tomorrow">${msg("Tomorrow")}</label>
                            </div>
                            <div class="input-group">
                                ${this.dates=='next-7-days'
                                    ? html`<input type="radio" name="dates" id="next-7-days" value="next-7-days" checked @change=${this._dateChange.bind(this)}/>`
                                    : html`<input type="radio" name="dates" id="next-7-days" value="next-7-days" @change=${this._dateChange.bind(this)}/>`
                                }
                                <label for="next-7-days">${msg("Next 7 days")}</label>
                            </div>
                            <div class="input-group">
                                ${this.dates=='custom'
                                    ? html`<input type="radio" name="dates" id="custom" value="custom" checked @change=${this._showDates.bind(this)}/>`
                                    : html`<input type="radio" name="dates" id="custom" value="custom" @change=${this._showDates.bind(this)}/>`
                                }
                                <label for="custom">${msg("Select dates")}</label>
                            </div>
                            <div class="input-group date-picker ${this.dates=='custom'?'':'hide'}" aria-live="polite">
                                <details class="date-picker-details bg_white" open>
                                    <summary>${this._dateRangeString}</summary>
                                    <div class="panel date-picker-panel">
                                        <lit-flatpickr
                                            dateformat="Y-m-d"
                                            altinput="true"
                                            altformat="j F Y"
                                            mindate="today"
                                            theme="none"
                                        >
                                            <div class="datetime_wrapper">
                                                <label for="start_date" class="screen-reader-text">${msg("Start date")}</label>
                                                <input name="start_date" value=${this.start_date} @change=${this._dateChange.bind(this)} />
                                                ${calendar}
                                            </div>
                                        </lit-flatpickr>
                                        <lit-flatpickr
                                            dateformat="Y-m-d"
                                            altinput="true"
                                            altformat="j F Y"
                                            mindate="today"
                                            theme="none"
                                        >
                                            <div class="datetime_wrapper ${!this.end_date ? 'hide' : ''}">
                                                <label for="end_date" class="screen-reader-text">${msg("End date")}</label>
                                                <input name="end_date" value=${this.end_date} @change=${this._dateChange.bind(this)} />
                                                ${calendar}
                                            </div>
                                            
                                        </lit-flatpickr>
                                        <div class="button-group date-picker-buttons">
                                            <button class="button_primary" @click=${this._applyDateRange.bind(this)}>${msg("Apply")}</button>
                                            <button class="button_secondary" @click=${this._resetDateRange.bind(this)}>${msg("Clear")}</button>
                                        </div>
                                    </div>
                                </details>
                            </div>
                        </div>
                </details>
                `
            }
            if(this.formats!==undefined){
                formatHtml = html`
                    <details class="filters" ?open="${!!this.format && this.format.length<3}">
                        <summary>Format</summary>
                        <div class="panel">
                            ${this.formats.map(format =>{
                                return html`
                                <div class="input-group">
                                    ${this.format.includes(format.name)
                                    ? html`<input type="checkbox" name="format" id="format-${format.name}" value="${format.name}" checked @change=${this._thereMustBeOne} />`
                                    : html`<input type="checkbox" name="format" id="format-${format.name}" value="${format.name}" @change=${this._thereMustBeOne} />`
                                    }
                                    <label for="format-${format.name}">
                                        ${format.label}
                                    </label>
                                </div>
                            `})}
                        </div>
                    </details>
                `;
            }
            if(this.prices!==undefined){
                pricesHtml = html`
                    <details class="filters" ?open="${!!this.price && this.price!=='All'}">
                        <summary>Price</summary>
                        <div class="panel">
                            ${this.prices.map(price => html`
                                <div class="input-group">
                                    ${this.price==price.name
                                        ? html`<input type="radio" name="price" id="price-${price.name}" value="${price.name}" checked />`
                                        : html`<input type="radio" name="price" id="price-${price.name}" value="${price.name}" />`
                                    }
                                    <label for="price-${price.name}">
                                        ${price.label}
                                    </label>
                                </div>
                            `)}
                        </div>
                    </details>
                `
            }
            if(this.accessibilities && this.accessibilities.length>0){
                accessibilitiesHtml = html`
                <details class="filters" ?open="${this.accessibility.length}">
                    <summary>${msg("Accessibility")}</summary>
                    <div class="panel">
                        <a href="#legend">${msg("View legend")}</a>
                        ${this.accessibilities.map(accessibility => html`
                            <div class="input-group">
                                ${this.accessibility.includes(accessibility.name)
                                ? html`<input type="checkbox" name="accessibility" id="accessibility-${accessibility.name}" value="${accessibility.name}" checked />`
                                : html`<input type="checkbox" name="accessibility" id="accessibility-${accessibility.name}" value="${accessibility.name}" />`
                                }
                                <label for="accessibility-${accessibility.name}">
                                    <span class="icon" aria-hidden="true" >${unsafeHTML(accessibility.icon?accessibility.icon:'')}</span>
                                    ${accessibility.label}
                                </label>
                            </div>
                        `)}
                    </div>
                </details>
                `;
            }
            if(this.supportTypes && this.supportTypes.length>0){
                supportTypesHtml = html`
                    <details class="filters" ?open="${this.supportType.length}">
                        <summary>${msg("Type of support")}</summary>
                        <div class="panel">
                            ${this.supportTypes.map(supportType => html`
                                <div class="input-group">
                                    ${this.supportType.includes(supportType.name)
                                    ? html`<input type="checkbox" name="supportType" id="supportType-${supportType.name}" value="${supportType.name}" checked />`
                                    : html`<input type="checkbox" name="supportType" id="supportType-${supportType.name}" value="${supportType.name}" />`
                                    }
                                    <label for="supportType-${supportType.name}">
                                        ${supportType.label}
                                    </label>
                                </div>
                            `)}
                        </div>
                    </details>
                `;
            }
            if(this.artforms && this.artforms.length>0){
                artformsHtml = html`
                    <details class="filters" ?open="${this.artform.length}">
                        <summary>${msg("Artform")}</summary>
                        <div class="panel">
                            ${this.artforms.map(artform => html`
                                <div class="input-group">
                                    ${this.artform.includes(artform.name)
                                    ? html`<input type="checkbox" name="artform" id="artform-${artform.name}" value="${artform.name}" checked />`
                                    : html`<input type="checkbox" name="artform" id="artform-${artform.name}" value="${artform.name}" />`
                                    }
                                    <label for="artform-${artform.name}">
                                        ${artform.label}
                                    </label>
                                </div>
                            `)}
                        </div>
                    </details>
                `;
            }
            if(this.operationIns && this.operationIns.length>0){
                operationInHtml = html`
                    <details class="filters" ?open="${this.operationIn.length}">
                        <summary>${msg("Operating in")}</summary>
                        <div class="panel">
                            ${this.operationIns.map(operation => html`
                                <div class="input-group">
                                    ${this.operationIn.includes(operation.name)
                                    ? html`<input type="checkbox" name="operationIn" id="operationIn-${operation.name}" value="${operation.name}" checked />`
                                    : html`<input type="checkbox" name="operationIn" id="operationIn-${operation.name}" value="${operation.name}" />`
                                    }
                                    <label for="operationIn-${operation.name}">
                                        ${operation.label}
                                    </label>
                                </div>
                            `)}
                        </div>
                    </details>
                `;
            }
           /*  if(this.languages && this.languages.length>0){
                languagesHtml = html`
                    <details class="filters" ?open="${this.language && this.language!=='en'}">
                        <summary>${msg("Languages")}</summary>
                        <div class="panel">
                            ${this.languages.map(language => html`
                                <div class="input-group">
                                    ${this.language===language.name
                                    ? html`<input type="radio" name="language" id="language-${language.name}" value="${language.name}" checked />`
                                    : html`<input type="radio" name="language" id="language-${language.name}" value="${language.name}" />`
                                    }
                                    <label for="language-${language.name}">
                                        ${language.label}
                                    </label>
                                </div>
                            `)}
                        </div>
                    </details>
                `;
            } */

            main=html`
            <form>
                <h3>Filter ${this.listingString} by:</h3>
                <div class="collapsers">
                    <button class="expand_all" @click=${this._expandCollapseAll}>${expandIcon}${msg(`Expand all`)}</button>
                    <button class="collapse_all" @click=${this._expandCollapseAll}>${collapseIcon}${msg(`Collapse all`)}</button>
                </div>
                ${typesHtml}
                ${formatHtml}
                ${pricesHtml}
                ${datesHtml}
                ${accessibilitiesHtml}
                ${supportTypesHtml}
                ${artformsHtml}
                ${operationInHtml}
                ${languagesHtml}
                <div class="button-group">
                    <button type="submit" @click=${this._handleSubmit}>${msg("View results")}</button>
                    <button type="reset" @click=${this._handleReset}>${msg("Clear filters")}</button>
                </div>
            </form>
            `;
        }
        return html`${main}`;
    }

    hasFilters(){
        return (this.search) || (this.addressSearch) || (this._type && this._type.length>0) || (this._accessibility && this._accessibility.length>0) || (this._artforms && this._artforms.length>0) || (this._supportTypes && this._supportTypes.length>0) ||(this._operationIn && this._operationIn.length>0) || (this.start_date) || (this.end_date) || (this.dates) || (this.format&&this.format!=='All') || (this.price&&this.price!=='All');
    }

    _handleFiltered(e){
        this._total = e.detail.total??0;
        this.search = e.detail.search??'';
        this.addressSearch = e.detail.addressSearch??'';
    }

    _handleReset(e){
        e.preventDefault();
        this.form.reset();
        this.search = '';
        this.addressSearch = '';
        this._type = [];
        this._accessibility = [];
        this._artforms = [];
        this._supportTypes = [];
        this._operationIn = [];
        this.eventManager.emit(`allin-${this.listingType}-filters-${this.name}`,{reset:'reset'});
        
    }

    _handleSubmit(e){
        e.preventDefault();
        let data = new FormData(this.form);
        //Form data to object
        let formData = {};
        data.forEach((value, key) => {
            if (formData[key]) {
                if (!Array.isArray(formData[key])) {
                    formData[key] = [formData[key]];
                }
                formData[key].push(value);
            } else {
                formData[key] = value;
            }
        });
        if(formData.end_date &&!formData.start_date){ 
            formData.start_date = formData.end_date;
        }
        formData.show = this.show;
        this.eventManager.emit(`allin-${this.listingType}-filters-${this.name}`,formData);
    }

    _showDates(e){
        e.preventDefault();
        let startInput = this.shadowRoot.querySelector('input[name="start_date"]');
        let endInput = this.shadowRoot.querySelector('input[name="end_date"]');
        this._dateRangeString = msg("Date range");
        const dateGroup = this.shadowRoot.querySelector('.date-picker');
        if(e.target.value==='custom'){
            dateGroup.classList.remove('hide');
        }
        else{
            dateGroup.classList.add('hide');
        }

    }

    _dateChange(e){
        e.preventDefault();
        let startInput = this.shadowRoot.querySelector('input[name="start_date"]');
        let endInput = this.shadowRoot.querySelector('input[name="end_date"]');
        const dateGroup = this.shadowRoot.querySelector('.date-picker');
        if(e.target.value == 'custom'||e.target.tagName=='BUTTON'){
            dateGroup.classList.remove('hide');
        }
        else if(e.target.value == '') {
            startInput.value = "";
            endInput.value = "";
            dateGroup.classList.add('hide');
        }
        else if(e.target.value=='today'){
            let today = new Date().toISOString().split('T')[0];
            startInput.value = today;
            endInput.value = today;
            dateGroup.classList.add('hide');
        }
        else if(e.target.value=='tomorrow'){
            let tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            startInput.value = tomorrow.toISOString().split('T')[0];
            endInput.value = tomorrow.toISOString().split('T')[0];
            dateGroup.classList.add('hide');
        }
        else if(e.target.value=='next-7-days'){
            let start = new Date();
            let end = new Date();
            end.setDate(end.getDate() + 7);
            startInput.value = start.toISOString().split('T')[0];
            endInput.value = end.toISOString().split('T')[0];
            dateGroup.classList.add('hide');
        }
        let start = startInput.value;
        let end = endInput.value;
        if(!start){
            endInput.parentElement.classList.add('hide');
        }
        else{
            endInput.parentElement.classList.remove('hide');
        }
        this._dateRangeString = dateToMaybeRange(start,end);
    }

    _setInitialDates(){
        const simulatedEvent = {target: {value: this.dates}};
        this._dateChange(simulatedEvent);
    }

    _applyDateRange(e){
        e.preventDefault();
        let startInput = this.shadowRoot.querySelector('input[name="start_date"]');
        let endInput = this.shadowRoot.querySelector('input[name="end_date"]');
        this._dateChange(e);
        this._handleSubmit(e);
    }

    _resetDateRange(e){
        e.preventDefault();
        this.shadowRoot.querySelector('input[name="date_start"]').value = '';
        this.shadowRoot.querySelector('input[name="date_end"]').value = '';
        this._dateRangeString = msg("Date range 3");
        this._handleSubmit(e);
    }

    _expandCollapseAll(e){
        e.preventDefault();
        let targets = this.shadowRoot.querySelectorAll('.filters');
        if(e.currentTarget.classList.contains('expand_all')){
            targets.forEach(target=>{
                target.setAttribute('open','');
            });
        }
        else{
            targets.forEach(target=>{
                target.removeAttribute('open');
            });
        }
    }

    _thereMustBeOne(e){
        const checkboxes = this.form.querySelectorAll(`input[name="${e.target.name}"]`);
        const checkedBoxes = Array.from(checkboxes).filter(checkbox => checkbox.checked);
        if(checkedBoxes.length === 0){
            e.target.checked = true;
        }
    }

    static styles = [
        grid,
        formStyles,
        accessibility,
        details,
        css`
        .icon{
            width:1.5rem;
            height:1.5rem;
            display:inline-block;
            svg{
                width:1.5rem;
                height:1.5rem;
                object-fit:contain;
            }
        }
        .border-top{
            border-top:1px solid var(--allin-highlight-color,#472961);
            padding-top:2rem;
            margin-bottom:2rem;
        }
        .border-top input[type="reset"]{
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            border:0;
            display:flex;
            gap:0.5rem;
            align-items:center;
            text-decoration:underline;
            cursor:pointer;
            transition:color var(--transition) ease;
            font-weight:700;
            font-size:1rem;
            margin-bottom:1rem;
        }

        .border-top strong{
            padding-right:1rem;
        }

        .searchboxes{
            display:grid;
            grid-template-columns:1fr 1fr auto;
            width:100%;
            max-width:800px;
            margin-bottom:2rem;
        }
        .searchbox{
            position:relative;
            label{
                margin-bottom:0.5rem;
            }
        }
        
        .searchbox input{
            padding-left:2.5rem;
            border-radius:0;
        }

        .searchbox:first-child input{
            border-radius:0.5rem 0 0 0.5rem;
            border-right:none;
        }

        input[type="submit"]{
            border-radius:0 0.5rem 0.5rem 0;
            height:calc(3rem + 2px);
            align-self:end;
        }

        p:has(+input[type="reset"]){
            padding-right:1rem;
            margin-right:1rem;
            position:relative;
            border-right:1px solid #6A6A6A;
        }


        .searchbox svg{
            position:absolute;
            left:0.5rem;
            bottom:0.8rem;
            width:1.5rem;
            height:1.5rem;
            path{
                fill:#6A6A6A;
            }
        }

        h3{
            font-size:1.2rem;
            font-weight:500;
            margin-top:0
        }

        details{
            border-top:1px solid #6A6A6A;
        }

        summary{
            color:var(--allin-highlight-color,#472961);
        }

        summary::after{
            opacity:0.7;
        }

        form{
            gap:0;
        }

        .button-group{
            display:flex;
            justify-content:space-between;
            margin-top:2rem;
            flex-wrap:wrap;
            gap: 1.5rem;
        }

        .button-group [type="reset"]{
            background-color:#727272;
        }
        
        .input-group{
            position:relative;
            gap:2rem;
            align-items:center;
            label{
                font-weight:400;
            }
        }
        .input-group::before{
            content:'';
            width:1.5rem;
            height:1.5rem;
            background-color:#fff;
            border:1px solid #6A6A6A;
        }
        .input-group::after{
            content:'';
            width:1rem;
            height:0.3rem;
            border-left:2px solid #000;
            border-bottom:2px solid #000;
            position:absolute;
            top:45%;
            left:0.25rem;
            transform:translateY(-50%) rotate(-45deg);
            opacity:0;
        }
        .input-group:has(input:checked)::after{
            opacity:1;
        }
        .input-group:has(:focus,:focus-visible){
            outline: 2px solid var(--allin-secondary-color,#FFC845);
            outline-offset: 2px;
        }
        .input-group:has(input:checked)::before{
            background-color:var(--allin-secondary-color,#FFC845);
        }
        .input-group:has(details)::before{
            display:none;
        }
        .input-group .date-picker-details{
            background-color: #FFFFFF;
            width: 100%;
            padding:0;
            border-top:0;
        }
        .input-group .date-picker-details summary{
            padding: 1rem;
            border: 1px solid #6A6A6A;
            margin:0;

        }

        .input-group .date-picker-details summary::after{
            width:12px;
            height:12px;
            top:1.4rem;
            right:1rem;
        }

        .date-picker-panel{
            padding: 1rem;
            border: 1px solid #6A6A6A;
            border-top:0;
            display:grid;
            gap:1rem;
        }

        .date-picker-buttons{
            margin-top:0;
        }

        input[type=checkbox],input[type=radio]{
            position:absolute;
            top:0;
            left:0;
            bottom:0;
            right:0;
            opacity:0;
            z-index:10;
        }

        label:has(.icon){
            display:grid;
            grid-template-columns:30px 1fr;
            gap:1rem;
            align-items:center;
        }

        .icon svg path,.icon svg circle,.icon svg rect, .icon svg ellipse, .icon svg polygon{
            fill:var(--allin-highlight-color,#472961);
        }

        .panel a{
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            margin-bottom:1rem;
            display:block;
        }

        .collapsers{
            margin-right:auto;
            margin-bottom:1rem;
            display: flex;
            gap: 1rem;
            width: fit-content;
        }
        .collapsers button{
            background-color: transparent;
            color: var(--allin-highlight-color,#472961);
            border: 0;
            cursor: pointer;
            font-weight: 700;
            font-size: 1rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            padding:1rem 0.2rem;
        }

        .ordering{
            justify-content:flex-start;
            gap:1rem;
            margin-bottom:2rem; 
            align-items:center;
        }
        .ordering label{
            width:fit-content;
        }
        .ordering select{
            width:200px;
            border-radius:2px;
        }
        .flex:has(+.ordering){
            margin-bottom:1rem;
        }
        @media screen and (width < 700px) {
            .searchboxes{
                grid-template-columns: 1fr 1fr;
            }
            .searchbox:last-of-type input{
                border-radius: 0 0.5rem 0.5rem 0;
            }
            .searchboxes input[type="submit"] {
                border-radius: 0.5rem;
                margin-top: 1rem;
                grid-column: 1 / -1;
            }
        }
        .searchboxes .searchbox label
        @media screen and (max-width: 999px) {
            .button-group{
                justify-content:start;
                gap: 1.5rem;
                margin-top: 1rem;
                margin-bottom: 3.5rem;
            }
        }
        `
        ];
}